import { Request } from 'commons/utils/request'

import {
  ChangeActiveStatusPayload,
  GetResetUrlPayload,
  ManageBankUserRequest,
  ResetUrlResponse,
  SendResetUrlPayload,
  UsersWebPagePayload,
  UsersWebPageResponse
} from './types'

export const api = {
  create: (user?: ManageBankUserRequest) => Request.post<void, ManageBankUserRequest>(Request.urls.bank.user, user),
  update: (user?: ManageBankUserRequest) => Request.put<void, ManageBankUserRequest>(Request.urls.bank.user, user),
  changeActiveStatus: (form?: ChangeActiveStatusPayload) =>
    Request.patch<void, ChangeActiveStatusPayload>(Request.urls.bank.userStatus, form),
  getResetUrl: (user?: GetResetUrlPayload) =>
    Request.post<ResetUrlResponse, GetResetUrlPayload>(Request.urls.bank.userPasswordResetUrl, user),
  sendResetUrl: (data?: SendResetUrlPayload) =>
    Request.post<unknown, SendResetUrlPayload>(Request.urls.bank.userAuthPasswordReset, data),
  getListPageOptions: (options?: UsersWebPagePayload) => ({
    queryKey: ['bank-users-page', options],
    queryFn: () =>
      Request.post<UsersWebPageResponse, UsersWebPagePayload>(Request.urls.bank.bankUserListWebpages, options)
  })
}
